// --- External Libraries
import moment from 'moment';
// --- Utils
import { extractErrorMessage } from 'datastage/utils/extractErrorMessage';
// --- Components
import { ClickableCellRenderer } from 'datastage/components/AGGrid/cell-renderers/clickable';
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header';

export const action = (onAddProducts) => ({
    headerName: 'Action',
    field: 'action',
    valueGetter: (params) => {
        if (params.data.action === 'COMPLETE') return 'COMPLETE';
        return params.data.action === 'UPDATE' ? 'UPDATE' : 'ADD';
    },
    cellRenderer: params => {
        if (params.data.action === 'COMPLETE') {
            return 'COMPLETE';
        }
        // Add tooltip with id value
        const Renderer = ClickableCellRenderer(onAddProducts, '');
        const element = Renderer(params);
        // Wrap in a span with title attribute for tooltip
        return (
            <span title={params.data.id || ''}>
                {element}
            </span>
        );
    },
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'action',
        page: 'productUpdates',
    },
    minWidth: 100,
});


export const message = {
    field: 'errorMessage',
    headerName: 'Message',
    valueGetter: (params) => extractErrorMessage(params.data?.errorMessage),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'errorMessage',
        page: 'productUpdates',
    },
    minWidth: 250,
    wrapText: true,
    autoHeight: true,
    cellStyle: { 
        paddingTop: '10px', 
        paddingBottom: '10px',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
};

export const id = {
    field: 'id',
    headerName: 'ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'productUpdates',
    },
    minWidth: 200,
    hide: true, // Hide the ID column
};

export const title = {
    field: 'title',
    headerName: 'Title',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'title',
        page: 'productUpdates',
    },
    minWidth: 500,
    wrapText: true,
    autoHeight: true,
    cellStyle: { 
        paddingTop: '10px', 
        paddingBottom: '10px',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
};

export const groupId = {
    field: 'groupId',
    headerName: 'Group ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'groupId',
        page: 'productUpdates',
    },
    minWidth: 150,
};

export const productId = {
    field: 'productId',
    headerName: 'Product ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productId',
        page: 'productUpdates',
    },
    minWidth: 150,
};

export const productNumber = {
    field: 'productNum',
    headerName: 'Product Number',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productNum',
        page: 'productUpdates',
    },
    minWidth: 150,
};

export const episodeTitle = {
    field: 'episodeTitle',
    headerName: 'Episode Title',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'episodeTitle',
        page: 'productUpdates',
    },
    minWidth: 400,
    wrapText: true,
    autoHeight: true,
    cellStyle: { 
        paddingTop: '10px', 
        paddingBottom: '10px',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
};

export const episodeNumber = {
    field: 'episodeNum',
    headerName: 'Episode Num',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'episodeNum',
        page: 'productUpdates',
    },
    minWidth: 150,
};

export const rightslineId = {
    field: 'rightslineId',
    headerName: 'Rightsline ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'rightslineId',
        page: 'productUpdates',
    },
    minWidth: 100,
};

export const actedOnDate = {
    field: 'actedOnDate',
    headerName: 'Acted On Date',
    valueFormatter: ({ value }) => (value ? moment(value).format('M/DD/YYYY') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'actedOnDate',
        page: 'productUpdates',
    },
    minWidth: 200,
};

export const actedOnBy = {
    field: 'actedOnBy',
    headerName: 'Acted On By',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'actedOnBy',
        page: 'productUpdates',
    },
    minWidth: 250,
};

export const updatedDate = {
    field: 'updatedDate',
    headerName: 'Updated Date',
    valueFormatter: ({ value }) => (value ? moment(value).format('M/DD/YYYY') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'updatedDate',
        page: 'productUpdates',
    },
    minWidth: 200,
};

export const ignore = (
    onChangeIgnoreFlag
) => ({
    headerName: 'Ignore',
    field: "ignoreFlag",
    valueGetter: (data) => {
        return data?.data.ignoreFlag ? 'UNIGNORE' : 'IGNORE';
    },
    cellRenderer: params =>
        ClickableCellRenderer(
            onChangeIgnoreFlag,
            params.data.ignoreFlag ? 'fa-eye' : 'fa-eye-slash'
        )(params),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'ignoreFlag',
        page: 'productUpdates',
    },
    minWidth: 125,
});